import { render, staticRenderFns } from "./data83.vue?vue&type=template&id=66a32308&scoped=true&"
import script from "./data83.vue?vue&type=script&lang=js&"
export * from "./data83.vue?vue&type=script&lang=js&"
import style1 from "./data83.vue?vue&type=style&index=1&id=66a32308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a32308",
  null
  
)

export default component.exports